import { Component, OnInit, ViewChildren, QueryList } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Constants } from '../../../../_utils/Constants';
import { $DBManagerService } from '../../../../_helpers/DB/DBManager.service';
import { MatPaginator, MatTableDataSource } from '@angular/material';
import { BehaviorSubject } from "rxjs/BehaviorSubject";
import { formatDate } from '@angular/common';
import { APILoginService } from '../../_services/login/API-login';
import { APIEntityService } from '../../_services/entity/API-entity';
import { $ModalManagerService } from 'src/app/_helpers/Modals/ModalManager.service';

const today = new Date();
var time_today = today.getTime();
var refid = "CID_" + time_today;



let now = new Date();
const currentdat = formatDate(now, 'yyyy-MM-dd', 'en-US', '+0530');
@Component({
  selector: 'app-invite-users',
  templateUrl: './invite-users.component.html',
  styleUrls: ['./invite-users.component.css']
})
export class InviteUsersComponent implements OnInit {
  dataSource: MatTableDataSource<any>;
  entityId: any;
  entityClass: any;
  entityAddr: any;
  orgType:  any;
  orgName:  any;
  childOrgFlag: any;
  childOrgName: any;
  entityRefNum: any;
  hashKycDoc: any;
  inviteId: any;
   dataSubject = new BehaviorSubject<any[]>([]);
  displayedColumns: string[] = ['Name', 'mobnum', 'Username', 'Status'];
    @ViewChildren(MatPaginator) paginator = new QueryList<MatPaginator>();

  constructor(
    private fb: FormBuilder,
    private db: $DBManagerService,
    private lo: APILoginService,
    private is: APIEntityService, 
    private $modal: $ModalManagerService,
  ) {
   this.getInvitedUserSummary()
  }

  inviteUsers: FormGroup;

  // For checking purpose to table
  inviteData: string;
  get f() 
  { 
    //console.log("Invite users getControls")
    return this.inviteUsers.controls;
  }


  ngOnInit() {
    
    this.inviteUsers = this.fb.group({
      name: ['', Validators.required],
      mobnum: ['', Validators.required],
      password: ['',Validators.pattern('(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[$@$!%*?&])[A-Za-z\d$@$!%*?&].{8,}')],      
      emailid: ['', [Validators.required, Validators.pattern(/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/ ) ]]

    })

    this.hashKycDoc = this.db.get(Constants.SESSSION_STORAGE, Constants.Hash_KYC_Doc);
    this.entityId = this.db.get(Constants.SESSSION_STORAGE, Constants.ENTITY_ID);
    this.entityClass = this.db.get(Constants.SESSSION_STORAGE, Constants.ENTITY_CLASS);
    this.entityAddr = this.db.get(Constants.SESSSION_STORAGE, Constants.ENTITY_ADDR);
    this.orgType = this.db.get(Constants.SESSSION_STORAGE, Constants.ORG_TYPE);
    this.orgName = this.db.get(Constants.SESSSION_STORAGE, Constants.ORG_NAME);
    this.childOrgFlag = this.db.get(Constants.SESSSION_STORAGE, Constants.CHILD_ORG_FLAG);
    this.childOrgName = this.db.get(Constants.SESSSION_STORAGE, Constants.CHILD_ORG_NAME);
   
    console.log(this.entityRefNum)
    console.log("###############Got from session ", this.hashKycDoc);
  }

  // entityForm.append('Entity_EMP_ID', Entity_EMP_ID);
 

 getInvitedUserSummary() {
 this.entityRefNum = this.db.get(Constants.SESSSION_STORAGE, Constants.ENTITY_REF_NO_LOGIN);
 console.log("inside the summary method",this.entityRefNum);
   var inviteId = {
"Invitee_ID" : this.entityRefNum
   }
  
this.is.getInvitedUserSummary(inviteId)

    .subscribe(r=>{
    console.log("calling invite users (entity summary)",r);
    // this.$modal.successModal({
    //   title: 'User Invited',
    //   msg: 'User has been invited.'
    // });
this.onDataSource(r);
    }); 

  }
    onDataSource(value) {
    this.dataSource = new MatTableDataSource(value);
    console.log("this.dataSource : ",this.dataSource)
    this.dataSource.paginator = this.paginator.toArray()[0];
    

    // this.noRecord = this.dataSource.connect().pipe(map(data => data.length === 0));
  }

  onSubmit() {
    // getting the value
    var data = {
      "Entity_ContactName": this.inviteUsers.get('name').value,
      "Entity_Mobile_No": this.inviteUsers.get('mobnum').value,
      "Entity_EmailID": this.inviteUsers.get('emailid').value,
      "Entity_Password": this.inviteUsers.get('password').value,
      "Entity_Class" : this.entityClass, //Taken from logged in user details
      "Entity_Addr" : this.entityAddr, //Taken from logged in user details
      "E_Org_Type" : this.orgType, //Taken from logged in user details
      "E_Org_Name" : this.orgName, //Taken from logged in user details
      "Entity_Name": this.orgName, //Taken from logged in user details
      "Child_Org_Flag" : this.childOrgFlag, //Taken from logged in user details
      "Child_Org_Name" : this.childOrgName, //Taken from logged in user details
      "E_Create_Date" : currentdat,
      "Entity_ID_Existing": 'N',
      "Hash_KYC_Doc": this.hashKycDoc,
      "Entity_ID": this.entityId, //Taken from logged in user details
      "Entity_Role": "NA", //To be assigned during Approval, requirement not finalised.
      "Entity_EMP_ID": "", //RIL id only for Jio employees
      "Invitee_ID" : this.entityRefNum, //Taken from logged in user details
    }
    console.log("data", data);
    this.lo.entityRegistration(data)
    .subscribe(r =>{
    console.log("calling invite users (entity registration)",r);
    if(r.usernamecheck === 'Username already exists')
    {
this.$modal.errorModal({
      title: 'Error',
      msg: 'user already exists'
    });
    }
else
{
 this.$modal.successModal({
      title: 'User Invited',
      msg: 'User has been invited.'
    });
this.getInvitedUserSummary();
}
   
    }); 
    


    


  }

  
}
